import { Component, input, output } from '@angular/core';
import { Store } from '@ngrx/store';

import { CheckInSelectors } from 'src/app/features/check-in/store';
import { PackageUsersSelectors } from 'src/app/features/package-users';

import { getAssociatedUsers } from '../../store/selectors/session-handoff.selectors';

@Component({
  selector: 'app-session-handoff-page',
  templateUrl: './session-handoff-page.component.html',
  styleUrls: ['./session-handoff-page.component.scss'],
  standalone: false,
})
export class SessionHandoffPageComponent {
  pageTitle = input.required<string>();
  cardTitle = input<string>('');
  cardMessage = input.required<string>();

  participantJoined = output<string>();

  participants = this.store.selectSignal(PackageUsersSelectors.selectNonSigningAgentsWithFullNames);
  associatedUsers = this.store.selectSignal(getAssociatedUsers);
  usersInWaitingRoom = this.store.selectSignal(CheckInSelectors.getUsersViewedWaitingRoom);

  constructor(private readonly store: Store) {}

  onJoinSession(packageUserGuid: string): void {
    this.participantJoined.emit(packageUserGuid);
  }
}
